import { createRouter, createWebHistory } from 'vue-router'
import { constantRouterMap, asyncRouterMap } from './routes'

export { constantRouterMap, asyncRouterMap }

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: () => ({ top: 0 }),
  routes: constantRouterMap
})

export default router